import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { SectionHeading } from './SectionHeading';
import { faqs } from '../data/content';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-cream px-4 py-16 sm:py-24" aria-labelledby="faq-title" data-id="element-115" data-mp="1geimufhsgv0a">
      <div className="mx-auto max-w-3xl" data-id="element-116" data-mp="2dz4s7mgu2g8g">
        <div id="faq-title" data-id="element-117" data-mp="291d3t2fedc90">
          <SectionHeading eyebrow="Frequently asked questions" title="Got Questions? Here Are the Answers" data-id="element-118" data-mp="2913bv9askv0o" />
        </div>

        <ul className="mt-10 space-y-3" data-id="element-119" data-mp="240ysnbii1m6r">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <li key={f.q} className="overflow-hidden rounded-2xl bg-white ring-1 ring-navy/10" data-id="element-120" data-mp="1z5jgqp41y0cz" data-mpi={i}>
                <button type="button" aria-expanded={isOpen} aria-controls={`faq-${i}`} onClick={() => setOpen(isOpen ? null : i)} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-gold" data-id="element-121" data-mp="skqqhb6zccvm">
                  <span className="font-serif text-[17px] font-bold leading-snug text-navy" data-id="element-122" data-mp="kiutjrtb5hi8">{f.q}</span>
                  <ChevronDownIcon aria-hidden="true" className={`h-5 w-5 shrink-0 text-gold transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} data-id="element-123" data-mp="6rq3nhfqs3l3" />
                </button>
                <AnimatePresence initial={false} data-id="element-124" data-mp="3t07t250oji4r">
                  {isOpen && <motion.div id={`faq-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-125" data-mp="1teqoxu5hcyn">
                      <p className="px-5 pb-5 text-[15px] leading-relaxed text-ink-muted" data-id="element-126" data-mp="1uinrr77f4nwg">{f.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>

        <div className="mt-10" data-id="element-127" data-mp="1fsq4cthbc28b">
          <CtaButton label="I Have No More Doubts — I Want It" data-id="element-128" data-mp="1ftrqbszva94t" />
        </div>
      </div>
    </section>;
}